import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { useTabs } from './context'
import useCallbackRef from '../hooks/useCallbackRef'
import { useConfig } from '../ConfigProvider'
import PropTypes from 'prop-types'

const TabNav = forwardRef((props, ref) => {
    const { value: valueProp, disabled, className, icon, children, ...rest } = props

    const { value, onValueChange, variant } = useTabs()
    const isSelected = valueProp === value

    const { themeColor, primaryColorLevel } = useConfig()
    
    const onTabNavClick = useCallbackRef(() => {
        if(!isSelected && !disabled) {
            onValueChange(valueProp)
        }
    })

    const tabNavClass = classNames(
        'tab-nav',
        `tab-nav-${variant}`,
        isSelected && 'tab-nav-active',
        isSelected && variant === 'underline' && `text-custom-600 border-custom-600`,
        isSelected && variant === 'pill' && 'bg-custom-600 border-custom-600 text-white shadow-sm',
        !isSelected && variant === 'pill' && 'text-gray-600 hover:text-custom-600 hover:border-gray-300',
        !isSelected && variant === 'underline' && 'text-gray-500 hover:text-custom-600',
        disabled && 'tab-nav-disabled',
        className
    )

    return (
        <div
            className={tabNavClass}
            role="tab"
            aria-selected={isSelected}
            ref={ref}
            onClick={onTabNavClick}
            {...rest}
        >
            {icon && <div className="tab-nav-icon">{icon}</div>}
            {children}
        </div>
    )
})

TabNav.propTypes = {
	disabled: PropTypes.bool,
	value: PropTypes.string.isRequired,
	icon: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
}

export default TabNav